import React from 'react';
import { Globe, Calculator, Award, TrendingUp, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Services = () => {
  const { t } = useLanguage();

  const services = [
    {
      icon: Globe,
      title: t('service-co2-web'),
      description: t('service-co2-web-desc'),
      features: [
        t('service-co2-web-feature-1'),
        t('service-co2-web-feature-2'),
        t('service-co2-web-feature-3'),
        t('service-co2-web-feature-4')
      ],
      link: "/services/co2-neutral-web"
    },
    {
      icon: Calculator,
      title: t('service-calculator'),
      description: t('service-calculator-desc'),
      features: [
        t('service-calculator-feature-1'),
        t('service-calculator-feature-2'),
        t('service-calculator-feature-3'),
        t('service-calculator-feature-4')
      ],
      link: "/services/co2-calculator"
    },
    {
      icon: Award,
      title: t('service-certificate'),
      description: t('service-certificate-desc'),
      features: [
        t('service-certificate-feature-1'),
        t('service-certificate-feature-2'),
        t('service-certificate-feature-3'),
        t('service-certificate-feature-4')
      ],
      link: "/services/co2-certificate"
    },
    {
      icon: TrendingUp,
      title: t('service-exchange'),
      description: t('service-exchange-desc'),
      features: [
        t('service-exchange-feature-1'),
        t('service-exchange-feature-2'),
        t('service-exchange-feature-3'),
        t('service-exchange-feature-4')
      ],
      link: "/services/co2-exchange"
    }
  ];

  return (
    <section id="services" className="section-padding bg-neutral-50">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-neutral-800 mb-6">
            {t('services-title')}
          </h2>
          <p className="text-xl text-neutral-600 max-w-3xl mx-auto">
            {t('services-subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {services.map((service, index) => (
            <Link to={service.link} key={index} className="bg-white rounded-2xl p-8 shadow-lg card-hover block hover:shadow-xl transition-all">
              <div className="flex items-center mb-6">
                <div className="bg-primary-100 p-3 rounded-xl mr-4">
                  <service.icon className="h-8 w-8 text-primary-600" />
                </div>
                <h3 className="text-2xl font-semibold text-neutral-800">
                  {service.title}
                </h3>
              </div>
              
              <p className="text-neutral-600 mb-6 leading-relaxed">
                {service.description}
              </p>

              <div className="space-y-3">
                {service.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-center space-x-3">
                    <CheckCircle className="h-5 w-5 text-primary-500 flex-shrink-0" />
                    <span className="text-neutral-700">{feature}</span>
                  </div>
                ))}
              </div>
            </Link>
          ))}
        </div>

        {/* Process Steps */}
        <div className="bg-white rounded-2xl p-8 shadow-lg">
          <h3 className="text-2xl font-semibold text-neutral-800 mb-8 text-center">
            {t('services-how-it-works')}
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-primary-600">1</span>
              </div>
              <h4 className="text-lg font-semibold text-neutral-800 mb-2">{t('services-step-1-title')}</h4>
              <p className="text-neutral-600 text-sm">
                {t('services-step-1-desc')}
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-primary-600">2</span>
              </div>
              <h4 className="text-lg font-semibold text-neutral-800 mb-2">{t('services-step-2-title')}</h4>
              <p className="text-neutral-600 text-sm">
                {t('services-step-2-desc')}
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-primary-600">3</span>
              </div>
              <h4 className="text-lg font-semibold text-neutral-800 mb-2">{t('services-step-3-title')}</h4>
              <p className="text-neutral-600 text-sm">
                {t('services-step-3-desc')}
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-primary-600">4</span>
              </div>
              <h4 className="text-lg font-semibold text-neutral-800 mb-2">{t('services-step-4-title')}</h4>
              <p className="text-neutral-600 text-sm">
                {t('services-step-4-desc')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services; 